export default __webpack_public_path__ + "static/media/Emblem_Master.3d0fff3d.webp";